import { combineReducers } from 'redux';
import MediaPlayer from './MediaPlayerReducer';
import NowPlaying from './NowPlayingReducer';
import AovivoBar from './AovivoBarReducer';
import Rating from './RatingReducer';
import Volume from './VolumeReducer';

const aovivoBar = combineReducers({
    MediaPlayer,
    NowPlaying,
    AovivoBar,
    Rating,
    Volume,
});

export default aovivoBar;
